import React from 'react'

const TextMessageContent = () => {
  return (
    <div>
      
    </div>
  )
}

export default TextMessageContent
